module.exports = __webpack_public_path__ + "img/RF-03.b44558e6.jpg";